import { Chip, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isCounterpartyFlow: boolean;
  className?: string;
};

export const CounterpartyFlowChip: React.FC<Props> = ({
  isCounterpartyFlow,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <Tooltip
        title={
          isCounterpartyFlow
            ? t('features.orders.counterparty_flow_succeeded')
            : t('features.orders.counterparty_flow_failed')
        }
      >
        <Chip
          label={t('features.orders.counterparty_label')}
          color={isCounterpartyFlow ? 'success' : 'error'}
          variant="outlined"
          size="small"
        />
      </Tooltip>
    </div>
  );
};
